import commonMessagesStore from '@/store/common-modules/messages';

export default {
  namespaced: true,
  modules: {
    commonMessagesStore,
  },
  actions: {
    async send ({ commit }, { id, skillsProfile, ...params }) {
      commit('prohub/jobsStore/addFilesToJob', { id, fileIds: params.files }, { root: true });
    },
  },
};
